var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$canAndRulesPass(_vm.user, 'setting.scales') || _vm.$canAndRulesPass(_vm.user, _vm.$permissions.CONFIGURABLE_SCALES.SEE_IN_MENU))?_c('div',[_c(_vm.scalesSettingsTemplate,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }